import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  },[])
  
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling
    });
  }, [location.pathname]); // Trigger effect on path change

  return null;
};

export default ScrollToTop;